import { h, Component } from 'preact';

export default class Invitation extends Component {
	render() {
		let base = this.props.filename;
		return (
			<picture>

				<source
					type="image/webp"
					srcset={`/assets/images/${base}-small.webp`}
					media="(max-width: 799px)"
				/>

				<source
					type="image/webp"
					srcset={`/assets/images/${base}-large.webp`}
					media="(min-width: 800px)"
				/>

				<img
					src={`/assets/images/${base}.png`}
					alt={this.props.alt}
				/>

			</picture>
		);
	}
}



// WEBPACK FOOTER //
// ./components/Image/index.js